<h2 mat-dialog-title>New Role</h2>
<mat-dialog-content>
  <mat-form-field class="w-full">
    <mat-label>{{'ROLE.ROLE' | translate}}</mat-label>
    <mat-select [formControl]="roleSelected">
      <mat-option *ngFor="let item of roleItems" [value]="item.id">
        {{ item.text | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="primary" (click)="onCancel()">{{'COMMON.CANCEL' | translate}}</button>
  <button mat-flat-button color="primary" (click)="onSubmit()">{{'COMMON.SAVE'
    | translate}}</button>
</mat-dialog-actions>